import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { PolygonShape, PolygonRibbon } from '../shape';
import { baseGeometryChannels, basePostInference, basePreInference, tooltip2d } from './utils';
var shape = {
  polygon: PolygonShape,
  ribbon: PolygonRibbon
};
/**
 * Convert value for each channel to polygon shapes.
 */
export var Polygon = function Polygon() {
  return function (index, scale, value, coordinate) {
    var Xn = Object.entries(value).filter(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        key = _ref2[0];
      return key.startsWith('x');
    }).map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        value = _ref4[1];
      return value;
    });
    var Yn = Object.entries(value).filter(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 1),
        key = _ref6[0];
      return key.startsWith('y');
    }).map(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 2),
        value = _ref8[1];
      return value;
    });
    var P = index.map(function (i) {
      var Pn = [];
      for (var j = 0; j < Xn.length; j++) {
        var x = Xn[j][i];
        if (x === undefined) break;
        var y = Yn[j][i];
        Pn.push(coordinate.map([+x, +y]));
      }
      return Pn;
    });
    return [index, P];
  };
};
Polygon.props = {
  defaultShape: 'polygon',
  defaultLabelShape: 'label',
  composite: false,
  shape: shape,
  channels: [].concat(_toConsumableArray(baseGeometryChannels({
    shapes: Object.keys(shape)
  })), [{
    name: 'x',
    required: true
  }, {
    name: 'y',
    required: true
  }]),
  preInference: _toConsumableArray(basePreInference()),
  postInference: [].concat(_toConsumableArray(basePostInference()), _toConsumableArray(tooltip2d()))
};